import { Grid, Typography, Box, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import AveragePriceByChildAgePoverty from './AveragePriceByChildAgePoverty';
import AveragePriceBySettingTypePoverty from './AveragePriceBySettingTypePoverty';
import CountyComparisonTablePoverty from './CountyComparisonTablePoverty';
import CountyContext from '../../contexts/CountyContext';
import CountyMapPoverty from './CountyMapPoverty';
import FiltersPoverty from './FiltersPoverty';
import FiltersContext from '../../contexts/FiltersContext';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row3() {
  const [familyType, setFamilyType] = useState('Family of 3');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const [county, setCounty] = useState(null);
  const [countyCode, setCountyCode] = useState(null);

  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <CountyContext.Provider value={{
        county, setCounty, countyCode, setCountyCode,
      }}
      >
        <SubquestionBox color={lightColor}>
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >

            <Grid item xs={12}>
              <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
                Affordability of care at FPL by county
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box displayPrint="none">
                <FiltersPoverty />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box displayPrint="none">
                <Typography variant="h6" align="center" style={{ textTransform: 'none' }}>
                  Click on a county below to see additional data
                </Typography>
              </Box>
              <ErrorBoundary>
                <CountyMapPoverty />
              </ErrorBoundary>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <AveragePriceBySettingTypePoverty height={300} />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <AveragePriceByChildAgePoverty height={300} />
                  </ErrorBoundary>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
          <div className="pagebreak100" />
          <Grid
            container
            spacing={2}
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item xs={12}>
              <ErrorBoundary>
                <CountyComparisonTablePoverty />
              </ErrorBoundary>
            </Grid>
          </Grid>
        </SubquestionBox>
      </CountyContext.Provider>
    </FiltersContext.Provider>
  );
}

export default Q1Row3;
